import styled, { css } from "styled-components";
import SanityMedia from "../sanity/SanityMedia";
import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect } from "react";
// import { ScreenReader } from '../../styles/mixins'

interface P {
  slides: any;
  setSlide: any;
  [key: string]: any;
}
const ProductSlideshow: React.FC<P> = ({
  slides,
  setSlide = () => null,
  ...props
}: P) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      // Watcher
      emblaApi.on("select", (e: any) => {
        setSlide(emblaApi.selectedScrollSnap());
      });

      // Initial state
      setSlide(emblaApi.selectedScrollSnap());
    }
  }, [emblaApi]);

  return (
    <Slider ref={emblaRef} {...props} $isSingle={slides?.length === 1}>
      <Container className="embla__container">
        {slides?.map((slide) => (
          <Slide key={slide._key} className="embla__slide">
            <Media ratio="3x4" media={slide} autoplay={true} />
          </Slide>
        ))}
      </Container>
      <PrevButton onClick={scrollPrev}>Prev</PrevButton>
      <NextButton onClick={scrollNext}>Next</NextButton>
    </Slider>
  );
};

const Slider = styled.div<{ $isSingle }>`
  overflow: hidden;
  /* display: flex; */
  /* overflow-x: scroll;*/
  position: relative;

  ${(p) =>
    p.$isSingle &&
    css`
      pointer-events: none;
    `}
`;

const Slide = styled.div`
  /* width: 100%;
flex-shrink: 0;*/
  flex: 0 0 100%;
  padding-top: 133%;
  position: relative;
`;

const Media = styled(SanityMedia)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  object-fit: cover;
  object-position: center;
`;

const Container = styled.div`
  display: flex;
  gap: 0 var(--gutter);
`;

const Button = styled.button`
  width: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 100;
  background: transparent;
  opacity: 0;
`;

const PrevButton = styled(Button)`
  left: 0;
  cursor: w-resize;
`;

const NextButton = styled(Button)`
  right: 0;
  cursor: e-resize;
`;

export default ProductSlideshow;
